import chain from 'src/static/vectors/socials/chain.svg';
import facebook from 'src/static/vectors/socials/facebook.svg';
import twitter from 'src/static/vectors/socials/twitter.svg';
import { CopySources } from 'src/types';

const ShareIcons = ({ handleCopy, url }: { handleCopy: (source: Required<CopySources>, text: string) => Promise<void>; url: string }) => {
	return (
		<div id="share-icons">
			<a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=Chat%20bot`} target="_blank" rel="noreferrer">
				<img data-name="twitter" src={twitter} alt="twitter illustration icon" />
			</a>
			<a target="_blank" href={`http://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}&t=Chat%20bot`} rel="noreferrer">
				<img data-name="facebook" src={facebook} alt="facebook illustration icon" />
			</a>
			<div onClick={() => handleCopy('copied.share', url)}>
				<img data-name="chain" src={chain} alt="chain illustration icon" />
			</div>
		</div>
	);
};

export default ShareIcons;
